export const CIP_NAMES = {
  "010000":"Agriculture, General",
"010001":"Supervised Agricultural Experience",
"010101":"Agricultural Business and Management, General",
"010102":"Agribusiness/Agricultural Business Operations",
"010103":"Agricultural Economics",
"010106":"Agricultural Business Technology",
"010201":"Agricultural Mechanization, General",
"010204":"Agriculture Power Machinery Operation",
"010205":"Agricultural Mechanics and Equipment/Machine Technology",
"010301":"Agricultural Production Operations, General",
"010302":"Animal/Livestock Husbandry and Production",
"010303":"Aquaculture",
"010308":"Agroecology and Sustainable Agriculture",
"010309":"Viticulture and Enology",
"010401":"Agricultural and Food Products Processing",
"010601":"Applied Horticulture/Horticultural Operations, General",
"010602":"Plant Systems Operation(s) & Management in Horticulture & Greenhouses",
"010603":"Ornamental Horticulture",
"010604":"Greenhouse Operations and Management",
"010605":"Landscaping and Groundskeeping",
"010607":"Turf and Turfgrass Management",
"010608":"Floriculture/Floristry Operations and Management",
"010802":"Agricultural Communications/Journalism",
"010901":"Animal Sciences, General",
"010906":"Livestock Management",
"011001":"Food Science",
"011002":"Food Technology and Processing",
"011101":"Plant Sciences, General",
"011103":"Horticultural Science",
"011201":"Soil Science and Agronomy, General",
"011202":"Soil Chemistry and Physics",
"018888":"Agriculture Cooperative Worksite Experience",
"030101":"Natural Resources/Conservation, General",
"030103":"Environmental Studies",
"030104":"Environmental Science",
"030198":"Sustainable Design and Technology",
"030201":"Natural Resources Management and Policy",
"030205":"Water, Wetlands, and Marine Resources Management",
"030301":"Fishing and Fisheries Sciences and Management",
"030501":"Forestry, General",
"030506":"Forest Management/Forest Resources Management",
"030508":"Urban Forestry",
"030601":"Wildlife and Wildlands Science and Management",
"038888":"Natural Resources and Conservation Cooperative Worksite Experience",
"090701":"TV/Radio Broadcast Journalism Technology",
"090903":"Advertising",
"091001":"Publishing",
"100201":"Photography and Video Foundations",
"100202":"Video Production Technology/Technician",
"100203":"Recording Arts and Sound Reinforcement Technology",
"100290":"Visual Communications",
"100301":"Graphic Communications Foundations",
"100303":"Prepress/Desktop Publishing and Digital Imaging Technology/Technician",
"100304":"Animation Technology/Video Graphics and Special Effects",
"108888":"Communication Technologies Cooperative Worksite Experience",
"110103":"Fundamentals of Information Technology",
"110201":"Computer Programming",
"110204":"Computer Game Programming",
"110601":"Digital Communication Tools",
"110699":"Office User Specialist",
"110701":"Introduction to Computer Science",
"110801":"WebPage/Digital/Multimedia and Information Design",
"110802":"Data Modeling and Database Administration",
"110803":"Video Game Design/Digital Computer Animation for Game Design",
"110901":"Computer Systems Networking and Telecommunications",
"111003":"Computer and Information Systems Security / Information Assurance",
"111006":"Computer Support Specialist",
"118888":"Computer and Information Sciences and Support Services Cooperative Worksite Experience",
"120401":"Cosmetology",
"120500":"Foods and Related Culinary Arts Foundations",
"120501":"Baking and Pastry Arts/Baker/Pastry Chef",
"120503":"Culinary Arts/Chefs Training",
"120505":"Food Production and Services",
"128888":"Personal and Culinary Services Cooperative Worksite Experience",
"130101":"Careers In Education",
"131501":"Educational Para Pro",
"138888":"Education Cooperative Worksite Experience",
"140102":"Pre-Engineering Technologies",
"140501":"Bioengineering and Biomedical Engineering",
"141001":"Electronics, Engineering and Design",
"141801":"Introduction to Materials Engineering",
"144201":"Mechatronics and Industrial Audomation",
"148888":"Engineering Cooperative Worksite Experience",
"149991":"Engineering Design 1",
"149992":"Engineering Design 2",
"149993":"Engineering Design 3",
"149994":"Introduction to Science Research in Engineering",
"149995":"Introduction to Engineering Technology",
"149996":"Introduction to Computer Integrated Manufacturing",
"149997":"Digital Electronics",
"149998":"Introduction to Aerospace Engineering",
"150201":"Introduction to Civil Engineering and Architecture",
"150405":"Industrial Robotics Technology/Technician",
"150406":"Robotics Foundations",
"150505":"Solar and Wind Energy Technology",
"150613":"Manufacturing Technology/Technician",
"150801":"Aeronautical and Aerospace Engineering Technology",
"151201":"Computer Engineering Technology",
"151202":"Computer Technology/Computer Systems Technology",
"151301":"Drafting and Design Technology General",
"151302":"CAD/CADD Drafting and/or Design Technology",
"151303":"High-Performance Green Building Architectural Drafting and Design",
"151304":"Civil Drafting and Civil Engineering CAD/CADD",
"151305":"Electrical/Electronics Drafting CAD/CADD",
"151306":"Mechanical Drafting and CAD/CADD",
"158888":"Engineering Technologies Cooperative Worksite Experience",
"160103":"Translation and Interpretation",
"161603":"Sign Language Interpretation/Interpreter",
"168888":"Linguistics Cooperative Worksite Experience",
"190001":"Personal Choices",
"190002":"Independent Living",
"190003":"Family Health",
"190401":"Consumer and Family Resources",
"190403":"Consumer Services",
"190501":"Nutrition and Wellness",
"190504":"Food Science, Dietetics, and Nutrition",
"190601":"Housing, Interiors and Furnishings",
"190701":"Human Development",
"190703":"Career, Community, and Family Connections",
"190704":"Family Systems",
"190706":"Child Development/Parenting",
"190707":"Family and Community Services",
"190708":"Early Childhood, Education and Services",
"190710":"Interpersonal Relationships",
"190726":"GRADS (Graduation, Reality and Dual Skills)",
"190901":"Textiles and Apparel",
"198888":"Family & Consumer Sciences Cooperative Worksite Experience",
"210198":"Technology Foundations",
"218888":"Technology Education Cooperative Worksite Experience",
"220001":"Business Law",
"220301":"Legal Administrative Assistant",
"231101":"Technical Communication",
"260102":"Biomedical Sciences",
"260103":"Biotechnology-Body Systems",
"260104":"Biomedical Innovation",
"261201":"Agricultural Biotechnology",
"261202":"Health Science Biotechnology",
"261302":"Marine Biology and Biological Oceanography",
"270301":"Applied Math",
"270305":"Financial Math",
"279991":"Technical Mathematics for the Trades",
"279998":"Business Math",
"280301":"JROTC Military Science",
"310101":"Hospitality, Tourism, and Recreation",
"310504":"Sports, Recreation and Entertainment Marketing and Management",
"310507":"Physical Fitness Technician",
"318888":"Hospitality, Tourism and Recreation Cooperative Worksite Experience",
"320107":"Career Choices",
"400891":"Principles of Technology Applied",
"401099":"Materials Science Technology Applied",
"422810":"Health/Medical Psychology",
"430100":"Public Safety and Security Foundations",
"430106":"Forensic Science Technology/Crime Scene Investigation",
"430107":"Criminal Justice/Police Science",
"430116":"Cyber/Computer Forensics",
"430203":"Fire Science/Fire Fighting",
"430206":"Wildland/Forest Firefighting and Investigation",
"438888":"Security and Protective Service Cooperative Worksite Experience",
"439901":"Emergency Dispatcher",
"450601":"Economics",
"460000":"Commercial Construction Trades",
"460100":"Architecture and Construction Foundations",
"460201":"Residential Carpentry/Carpenter",
"460290":"Marine Carpentry/Boat Building",
"460302":"Green Residential Electrician",
"468888":"Construction Trades Cooperative Worksite Experience",
"469998":"Pre-Apprenticeship Skills for the Trades",
"470000":"Manufacturing Foundations",
"470100":"Energy and Power Foundations",
"470101":"Electrical Equipment Installation and Repair",
"470104":"Computer Installation and Repair Technology/Technician",
"470201":"HVAC/HVACR Maintenance Technology/Technician",
"470495":"Computer Integrated Manufacturing",
"470600":"Automotive Foundations",
"470603":"Auto Body/Collision Repair Technology/Technician",
"470604":"NATEF/ASE Automotive Technician",
"470605":"Diesel Mechanic and Repair",
"470606":"Power Equipment Small Engine Technology/Technician",
"470607":"Aircraft Mechanic and Aircraft Maintenance Technology/Technician",
"470616":"Marine Maintenance and Ship Repair Technology/Technician",
"470688":"Auto Detailer",
"470698":"Automobile/Automotive General Service Technician",
"478888":"Mechanic and Repair Technologies Cooperative Worksite Experience",
"480000":"Precision Production Trades Foundations",
"480503":"Machine Shop Technology/Technician",
"480508":"Welding Technology",
"480511":"Metal Fabricator",
"480701":"Woodworking Foundations",
"480703":"Cabinetmaking and Millwork/Mill Wright",
"488888":"Precision Production Cooperative Worksite Experience",
"490102":"Airline/Commercial Pilot and Flight Crew",
"490309":"Merchant Marine Officer/Crew",
"498888":"Transportation and Materials Moving Cooperative Worksite Experience",
"500102":"Digital Arts",
"500402":"Graphic Design/Commercial and Advertising Art",
"500406":"Commercial Photography",
"500499":"Design and Commercial Art Foundations",
"500502":"Technical Theater/Theater Design Technology/Technician",
"500510":"Costume Design",
"500602":"Cinematography and Cinema Production",
"500713":"Metal and Jewelry Arts",
"500797":"Professional Production Arts Technology/Technician",
"508888":"Visual and Performing Arts Cooperative Worksite Experience",
"510000":"Introduction to Health Science Careers",
"510601":"Dental Assisting",
"510700":"Health Informatics Careers Strand",
"510710":"Support Services Careers Strand",
"510717":"Medical Intervention",
"510799":"Medical Terminology",
"510800":"Therapeutic Services, other",
"510801":"Medical Assistant",
"510805":"Pharmacy Pre-Technician/Assistant",
"510806":"Physical Therapist Technician/Aide",
"510808":"Veterinarian Assistant",
"510900":"Diagnostic Services Careers Strand",
"510913":"Sports Medicine",
"511199":"Pre-Allied Health Program",
"511614":"Nursing Assistant",
"512208":"Systems Medicine",
"512210":"Global Health",
"512699":"Home Care Aide",
"518888":"Health Sciences Cooperative Worksite Experience",
"520000":"Introduction to Business",
"520201":"Business Administration Management",
"520204":"Business Office Management",
"520211":"Project Management",
"520301":"Accounting",
"520302":"Accounting Technology",
"520401":"Business Procedures and Administrative Support Services",
"520501":"Business Communications",
"520701":"Entrepreneurship",
"520703":"Small Business Administration/Management",
"520801":"Finance",
"520803":"Banking and Financial Services",
"520901":"Hospitality Administration and Management",
"520905":"Restaurant/Food Services Management",
"521101":"International Business and Commerce",
"521400":"Introduction to Marketing",
"521401":"Marketing Management",
"521403":"International Marketing",
"521801":"Marketing Operations",
"521804":"Selling Skills and Sales Operations",
"521902":"Fashion Merchandising",
"521906":"Tourism Promotion Operations",
"521907":"Vehicle Parts and Accessories Marketing Operations",
"521999":"Social Media Marketing",
"528888":"Business & Marketing Education Cooperative Worksite Experience",
  };